import { NotFound } from './notFound';
/**
 *  The exception that is thrown when the card is not found.
 *  The server can not find the requested resource.
 *  HTTP Response Status Code 404
 *
 * @param message The message that will be returned to the user
 * @param eventName Identification of the event that triggered the error
 */
export class CardNotFound extends NotFound {
    constructor(message) {
        super(message !== null && message !== void 0 ? message : `Card not found`, 'CardNotFound');
    }
}
//# sourceMappingURL=cardNotFound.js.map